<template>
    <div>
        <!-- Alterar Data Laudo -->
        <div class="modal fade" id="alterarDataLaudoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Alterar Data do Exame
                            <span v-if="laudo" class="badge badge-secondary ml-3">{{ laudo.id_laudo }}</span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="laudo">
                        <div class="alert alert-info">
                            <div class="lead">{{ laudo.atendimento_procedimento.atendimento.paciente.st_nome }}</div>
                            <div>{{ laudo.atendimento_procedimento.procedimento.search }}</div>
                            <div>#{{ laudo.atendimento_procedimento.id_atendimento }}</div>
                        </div>

                        <az-input
                            label="Data do Exame"
                            type="datetime-local"
                            required
                            :validate="validate"
                            v-model="laudo.dt_inclusao" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() {
        return { 
            laudo: null, 
            validate: false, 
        }
    },

    components: { 
        AzInput,
        AzSubmit
    },

    methods: { 
        abrir (laudo) { 
            this.validate = false; 
            this.laudo = _.cloneDeep(laudo);
            $('#alterarDataLaudoModal').modal('show');
        },

        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'laudos', 
                func: 'alterar_data_exame', 
                dados: this.laudo, 
                modal: 'alterarDataLaudoModal',
                toast: true, 
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        }
    }
}
</script>
